import rejectionTypesModule from '@/store/modules/requests/rejection_types/module';

const registerRejectionTypes = (store) => {
  rejectionTypesModule(store);

  store.dispatch('requests/rejectionTypes/initItems');
};

export default registerRejectionTypes;
